import { render, staticRenderFns } from "./HelpModal.vue?vue&type=template&id=5b1dc98e&scoped=true&lang=pug&"
import script from "./HelpModal.vue?vue&type=script&lang=js&"
export * from "./HelpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1dc98e",
  null
  
)

export default component.exports